/* AutoFxMart — Velocity theme runtime
   - dark/light toggle (persisted; light is the default)
   - reveal-on-scroll (respects prefers-reduced-motion)
   - live "ships today" countdown for [data-afx-shipby]
   No framework. ~3kb. */
(function () {
  'use strict';
  var KEY = 'afx-theme';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- theme ---- */
  function current() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
  function apply(t) {
    root.setAttribute('data-theme', t);
    document.querySelectorAll('[data-afx-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(t === 'dark'));
      var on = b.querySelector('[data-afx-toggle-on]');   // shown in dark
      var off = b.querySelector('[data-afx-toggle-off]'); // shown in light
      if (on) on.hidden = t !== 'dark';
      if (off) off.hidden = t === 'dark';
    });
  }
  function toggle() {
    var t = current() === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(KEY, t); } catch (e) {}
    apply(t);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-afx-theme-toggle]');
    if (t) { e.preventDefault(); toggle(); }
  });
  apply(current());

  /* ---- reveal on scroll ---- */
  function reveal() {
    var els = document.querySelectorAll('[data-afx-reveal]:not(.afx-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('afx-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('afx-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- ships-today countdown: <span data-afx-shipby="15:00"> ---- */
  function shipCountdown() {
    var nodes = document.querySelectorAll('[data-afx-shipby]');
    if (!nodes.length) return;
    function tick() {
      var now = new Date();
      nodes.forEach(function (n) {
        var hm = (n.getAttribute('data-afx-shipby') || '15:00').split(':');
        var cut = new Date(now); cut.setHours(+hm[0] || 15, +hm[1] || 0, 0, 0);
        var out = n.querySelector('[data-afx-shipby-out]') || n;
        if (now < cut) {
          var ms = cut - now, h = Math.floor(ms / 3.6e6), m = Math.floor((ms % 3.6e6) / 6e4);
          out.textContent = h + 'h ' + m + 'm';
          n.removeAttribute('data-afx-late');
        } else {
          out.textContent = 'tomorrow';
          n.setAttribute('data-afx-late', '');
        }
      });
    }
    tick(); setInterval(tick, 30000);
  }

  function init() { reveal(); shipCountdown(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
